export class OfflineStorage {
    public static getClassName(): string {
        return "OfflineCache";
    }
}

export interface IOfflineStorage {
    read(key: string): any;
    write(key: string, value: any): void;
    readString(key: string): string | null;
    writeString(key: string, value: string): void;
    remove(key: string): void;
}
